import type { InjectionKey } from 'vue'

import type { StorageLike } from '@vueuse/core'

export const VOTED_REVIEWS_STORAGE_INJECTION_KEY = Symbol(
  'review-votes-storage',
) as InjectionKey<StorageLike>
